<div class="feedback-widget" [class.open]="isOpen()">
  @if (isOpen()) {
    <div class="feedback-backdrop" (click)="onBackdropClick()" aria-hidden="true"></div>

    <aside
      class="feedback-panel"
      role="dialog"
      aria-labelledby="feedback-panel-title"
      [attr.aria-hidden]="!isOpen()"
    >
      <header class="feedback-header">
        <div class="feedback-header__content">
          <img class="feedback-header__logo" [src]="logo" alt="" />
          <h2 class="feedback-header__title" id="feedback-panel-title">{{ panel.title }}</h2>
        </div>
        <button type="button" class="feedback-close" (click)="close()" aria-label="Close feedback">
          <i class="bi bi-x-lg" aria-hidden="true"></i>
        </button>
      </header>

      <div class="feedback-items">
        @for (item of items; track item.title) {
          <button type="button" class="feedback-item" (click)="onItemSelect(item)">
            <span class="feedback-item__icon" aria-hidden="true">
              @switch (item.icon) {
                @case ('bug') {
                  <i class="bi bi-bug"></i>
                }
                @case ('improve') {
                  <i class="bi bi-lightbulb"></i>
                }
                @case ('support') {
                  <i class="bi bi-headset"></i>
                }
              }
            </span>
            <span class="feedback-item__text">
              <span class="feedback-item__title">{{ item.title }}</span>
              <span class="feedback-item__subtitle">{{ item.subtitle }}</span>
            </span>
            @if (item.action.kind === 'survey') {
              <i class="bi bi-box-arrow-up-right feedback-item__arrow" aria-hidden="true"></i>
            } @else {
              <i class="bi bi-chevron-right feedback-item__arrow" aria-hidden="true"></i>
            }
          </button>
        }
      </div>

      <div class="feedback-survey">
        <p class="feedback-survey__title">{{ panel.surveyTitle }}</p>
        <p class="feedback-survey__text">{{ panel.surveyText }}</p>
        <button type="button" class="feedback-survey__btn" (click)="openSurvey()">
          {{ panel.surveyCta }}
          <i class="bi bi-box-arrow-up-right" aria-hidden="true"></i>
        </button>
      </div>
    </aside>
  }

  <button
    type="button"
    class="feedback-fab"
    (click)="toggle()"
    [attr.aria-expanded]="isOpen()"
    aria-controls="feedback-panel-title"
    [attr.aria-label]="isOpen() ? 'Close feedback' : 'Open feedback'"
  >
    <i class="bi" [class.bi-x-lg]="isOpen()" [class.bi-chat-square-text]="!isOpen()" aria-hidden="true"></i>
    <span class="feedback-fab__label">{{ isOpen() ? 'Close' : 'Feedback' }}</span>
  </button>
</div>
